module.exports = __webpack_public_path__ + "img/text.66985a01.png";